<template>
  <v-dialog v-model="visible" persistent max-width="600px" scrollable>
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">Agregar alumno</span>
      </v-card-title>
      <v-card-text>
        <v-container px-0 py-0 v-if="loading.working">
          <span>Cargando alumnos...</span>
        </v-container>
        <v-container px-0 py-0 v-if="loading.error">
          <span class="primary--text">{{ loading.error }}</span>
        </v-container>
        <v-container px-0 py-0 v-if="loading.success && students.length > 0">
          <v-radio-group v-model="idStudent">
            <v-radio
              v-for="student in students"
              :key="student.id"
              :label="`${student.firstName} ${student.lastName}`"
              :value="student.id"
              color="primary"
            ></v-radio>
          </v-radio-group>
        </v-container>
        <v-container px-0 py-0 v-if="loading.success && students.length === 0">
          No hay alumnos disponibles
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn flat @click="cancel">Cancelar</v-btn>
        <v-btn
          :disabled="!idStudent"
          color="primary darken-1"
          flat
          @click="confirm"
          >Agregar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    subgroup: {},
  },
  data: () => ({
    idStudent: undefined,
    visible: true,
    students: [],
    loading: {
      working: true,
      success: false,
      error: "",
    },
    submitting: {
      working: false,
      error: "",
    },
  }),
  methods: {
    cancel() {
      this.$emit("cancelled");
    },
    confirm() {
      if (!this.idStudent) return;
      var data = { idStudent: this.idStudent };
      this.$emit("confirmed", data);
    },
  },
  mounted() {
    this.loading.working = true;
    this.$store
      .dispatch("subgroups/availableStudents", {
        idLevel: this.subgroup.idLevel,
        idGradeGroup: this.subgroup.idGradeGroup,
      })
      .then((data) => {
        this.students = data.data.items;
        this.loading.success = true;
      })
      .catch((error) => {
        this.loading.error = error.message;
      })
      .finally(() => {
        this.loading.working = false;
      });
  },
};
</script>
<style>
</style>